import { MetaTagEndpoints, MetaTagInfo, MetaTags } from 'src/services/metaTag'
import { APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES } from 'src/config/request/hotClubHttp'
import { useHotRequest } from '@hotmart-org-ca/hot-club-http/client/hooks'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { UseGetLinkPreviewProps } from './useGetLinkPreview.types'

const useGetLinkPreview = ({ linkUrl }: UseGetLinkPreviewProps) => {
  const endpoint = MetaTagEndpoints.linkPreview()
  const neededMetaTags = [MetaTags.IMAGE_TAG, MetaTags.TITLE_TAG, MetaTags.URL_TAG]
  const metaTagKey = 'metaTags'
  const params = new URLSearchParams({
    url: linkUrl
  })

  neededMetaTags.forEach((metaTag: MetaTags) => params.append(metaTagKey, metaTag))

  return useHotRequest<MetaTagInfo>(endpoint, {
    cacheKey: [endpoint, linkUrl],
    instanceName: APP_MEMBERSHIP_COMMUNITY_CONSUME_HOT_HTTP_INSTANCES.API_SCRAPER,
    params: params as unknown as Record<string, unknown>,
    queryOptions: {
      enabled: Boolean(linkUrl),
      ...DEFAULT_CACHE_CONFIG
    }
  })
}

export default useGetLinkPreview
